var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuToolsHandoverGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "rgb(255, 255, 255)",
      fontFamily: "Arial, sans-serif",
      fontSize: 250,
      whiteSpace: "pre"
    },
    transform: "matrix(1.0002, 0, 0, 1.0002, 0.403676, -0.050017)",
    x: 244.08,
    y: 418.944
  }, "B", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 244.0800018310547,
    dy: "1em"
  }, "\u200B"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.099383, 0, 0, 0.9998, -21.657843, 0.199942)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.7,146.5c7.8,0.9,14.8-4.7,15.7-12.5c4-35.6,17-62.5,38.7-79.9c21.3-17.1,51.7-25.8,90.3-25.8 c42.6,0,75.2,10.6,96.8,31.6c22.2,21.6,33.5,55.2,33.5,99.8l-0.2,13.8c0,0.1,0,0.1,0,0.2c0,4.6-0.7,11-4.3,14.5 c-2.8,2.8-7.5,4.3-13.9,4.3h-2.7c1.2-7.9,1.8-16.4,1.8-25.3c0-72.1-39.5-111.8-110.9-111.8s-111,39.6-111,111.7 s39.4,111.8,110.9,111.8c51,0,85.7-20.2,101.3-58h10.4c14.1,0,25.5-4.3,33.7-12.5c8.3-8.3,12.7-20.2,12.7-34.6l0.2-13.8 c0-0.1,0-0.1,0-0.2c0-52.6-14.2-93.1-42.2-120.4c-27-26.3-66.1-39.6-116.3-39.6c-45.1,0-81.4,10.7-107.9,32 c-27.7,22.3-44.2,55.5-49.1,98.9C89.4,138.5,94.9,145.6,102.7,146.5z M308.9,230.7c-13.6,13.2-34.2,19.8-61.5,19.8 s-48-6.7-61.5-19.8c-14-13.6-21.1-34.9-21.1-63.5s7.1-49.9,21.1-63.5c13.6-13.2,34.2-19.8,61.5-19.8c27.4,0,48.1,6.6,61.5,19.8 c14,13.6,21.1,34.9,21.1,63.5c0,9.2-0.7,17.6-2.2,25.3h-32.2c-4-5.9-10.8-9.3-19.7-9.3c-14.6,0-23.6,9.1-23.6,23.7 c0,7.3,2.1,12.9,6.2,17.2s10.2,6.5,17.4,6.5c7.2,0,13.4-2.3,17.5-6.5c0.9-1,1.7-2,2.5-3.1H317C314.5,224.5,311.9,227.8,308.9,230.7 z",
    style: {
      fill: "#86888C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.8,345.8c-25.5-26.7-63.3-40.8-109.3-40.8H164.8c-46,0-83.8,14.1-109.3,40.8 c-23.4,24.5-35.8,58.6-35.8,98.3v41.6c0,7.8,6.4,14.2,14.1,14.2h426.6c7.8,0,14.1-6.3,14.1-14.2v-41.6 C474.6,404.4,462.2,370.4,438.8,345.8z M446.4,471.5H48v-27.4c0-32.3,9.7-59.5,27.9-78.5c20.3-21.3,50.2-32.1,89-32.1h164.6 c38.7,0,68.7,10.8,89,32.1c18.2,19.1,27.9,46.2,27.9,78.5V471.5z",
    style: {
      fill: "#86888C"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuToolsHandoverGray);
export default __webpack_public_path__ + "static/media/ic-menu-tools-handover-gray.276778af6e7ce59c87c5233a141c74e3.svg";
export { ForwardRef as ReactComponent };